
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { ProductCategory } from './product-category-entity';


export class ProductCategoryType extends BaseEntity {
  
  productCategory         : ProductCategory = new ProductCategory();
  productCategoryTypeCode : string;
  name                    : string;
  rank                    : number;
  
  constructor() {
   super()
  }
  
}
